var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-full px-2 py-1 inline-flex items-center justify-center",class:_vm.currentBgClass},[_c('span',{class:[_vm.textClass, _vm.currentTextColorClass]},[_vm._t("default"),(_vm.text && !_vm.$slots.default)?[_vm._v(" "+_vm._s(_vm.text)+" ")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }